const MIN_MS = 60_000;
const HOUR_MS = 3_600_000;
const DAY_MS = 86_400_000;

const plural = (n: number, unit: string) =>
  `${n} ${unit}${n === 1 ? '' : 's'} ago`;

// Formats a timestamp as "just now", "5 mins ago", "3 hours ago", "2 days ago".
// `now` is injectable so tests don't depend on Date.now().
export const formatTimeAgo = (
  iso: string,
  now: number = Date.now()
): string => {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diff = Math.max(0, now - then);

  if (diff < MIN_MS) return 'just now';
  if (diff < HOUR_MS) return plural(Math.floor(diff / MIN_MS), 'min');
  if (diff < DAY_MS) return plural(Math.floor(diff / HOUR_MS), 'hour');
  return plural(Math.floor(diff / DAY_MS), 'day');
};
